import { connect } from 'react-redux'
import { AppBar } from './AppBar.jsx'
import {
    isThumbnailsAsideDisplayed,
    isTableOfContentsAsideDisplayed,
    isPrintPreviewAsideDisplayed,
    isCollaborativeIndexationAsideDisplayed,
    isCollaborativeIndexationCreationAsideSelected,
    isSocialSharingAsideDisplayed,
} from '../../../redux/aside/selectors'
import { isUserCollaborativeIndexerStatusActive } from '../../../redux/app/selectors'

const mapStateToProps = state => ({
    isCollaborativeIndexationAsideDisplayed: isCollaborativeIndexationAsideDisplayed(state),
    isCollaborativeIndexationCreationAsideDisplayed: isCollaborativeIndexationCreationAsideSelected(state),
    isThumbnailsAsideDisplayed: isThumbnailsAsideDisplayed(state),
    isTableOfContentsAsideDisplayed: isTableOfContentsAsideDisplayed(state),
    isPrintPreviewAsideDisplayed: isPrintPreviewAsideDisplayed(state),
    isUserCollaborativeIndexerStatusActive: isUserCollaborativeIndexerStatusActive(state),
    isSocialSharingAsideDisplayed: isSocialSharingAsideDisplayed(state),
})

export const AppBarContainer = connect(
    mapStateToProps,
)(AppBar)
